import { render } from "./TheExercise.vue?vue&type=template&id=2bd9466a&scoped=true"
import script from "./TheExercise.vue?vue&type=script&lang=js"
export * from "./TheExercise.vue?vue&type=script&lang=js"

import "./TheExercise.vue?vue&type=style&index=0&id=2bd9466a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd9466a"]])

export default __exports__